import { addOAuthAuthorizationCodeIntoCallbackUrlQueryArgs, addOAuthAuthorizationErrorIntoCallbackUrlQueryArgs, fetchOAuthCode } from '../../state'
import { oAuthErrorQueryParamMapper, shouldAttemptAccountLink, toOAuthScopeArray } from '../../utils/oAuth'
import { unwrapResult } from '@reduxjs/toolkit'
import { OAuthError, OAuthState } from '../../model'
import { valueIsNotNullOrUndefined } from '@afterpay/utils'

export const oAuthAuthorization = async (dispatch, logEvent, oAuthState: OAuthState): Promise<void> => {
  const doOAuthAuthorization = async (): Promise<void> => {
    if (!shouldAttemptAccountLink(oAuthState)) {
      return
    }

    if (valueIsNotNullOrUndefined(oAuthState.error)) {
      await handleOAuthAuthorizationError(dispatch, oAuthState.error, oAuthState.state ?? '')
    } else {
      const { clientId, responseType, scope, redirectUri } = oAuthState
      try {
        const { code } = unwrapResult(
          await dispatch(
            fetchOAuthCode({
              clientId,
              scopes: toOAuthScopeArray(scope),
              grantType: responseType,
              redirectUri,
            })
          )
        )
        await dispatch(
          addOAuthAuthorizationCodeIntoCallbackUrlQueryArgs({
            code,
            state: oAuthState.state,
          })
        )
        logEvent('Checkout OAuth Authorization Succeeded')
      } catch (e) {
        await handleOAuthAuthorizationError(dispatch, e, oAuthState.state ?? '')
        logEvent('Checkout OAuth Authorization failed')
      }
    }
  }

  await doOAuthAuthorization()
}

const handleOAuthAuthorizationError = async (dispatch, error: OAuthError, state: string): Promise<void> => {
  const errorQueryParam = oAuthErrorQueryParamMapper(error)
  await dispatch(
    addOAuthAuthorizationErrorIntoCallbackUrlQueryArgs({
      error: errorQueryParam,
      state,
    })
  )
}
